/**
 *
 */
import {AxiosResponse} from "axios";

export default class ResponseMessenger {
    protected messages: string[] = [];


    protected textMessage = '';

    /**
     * 422, APIのバリデーションエラーをalertで実行可能な形に整形します。
     * @param response
     */
    public parse422MessageResponse(response: AxiosResponse): void {
        this.clear();
        for (const i in response.data.errors) {
            const errorMessage = String(response.data.errors[i] + "\n");
            this.messages.push(errorMessage);
            this.textMessage += errorMessage;
        }
    }

    /**
     * @param response
     */
    public parseMessageResponse(response: AxiosResponse): void {
        this.clear();
        if(response.status === 422){
            this.parse422MessageResponse(response);
            return;
        }
        this.messages.push(response.data);
        this.textMessage += response.data;
    }

    private clear()
    {
        this.messages = [];
        this.textMessage = '';
    }

    public getMessages() {
        return this.messages;
    }

    /**
     *
     */
    public getTextMessage(): string {
        return this.textMessage;
    }
}